export const NEW_MESSAGE = 0
export const NEW_DEAL_MESSAGE = 1
